import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  RegReportFilter,
  RegistrationReportData,
  GraphData,
} from 'src/app/class/datatype';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  constructor(private http: HttpClient) {}

  registrationByTime(
    filter: RegReportFilter
  ): Observable<RegistrationReportData[]> {
    let params = new HttpParams();

    if (filter.scale) {
      params = params.append('scale', filter.scale.toString());
    }

    if (filter.status) {
      params = params.append('status', filter.status.toString());
    }

    if (filter.startDate) {
      params = params.append('startDate', filter.startDate.toString());
    }

    if (filter.endDate) {
      params = params.append('endDate', filter.endDate.toString());
    }

    return this.http.get<RegistrationReportData[]>(
      environment.apiUrl + 'clientapi/report/registration-by-time',
      { params }
    );
  }

  registrationByGroup(filter: RegReportFilter): Observable<GraphData[]> {
    let params = new HttpParams();

    if (filter.group) {
      params = params.append('group', filter.group.toString());
    }

    if (filter.startDate) {
      params = params.append('startDate', filter.startDate.toString());
    }

    if (filter.endDate) {
      params = params.append('endDate', filter.endDate.toString());
    }

    return this.http.get<GraphData[]>(
      environment.apiUrl + 'clientapi/report/registration-by-group',
      { params }
    );
  }
}
